import { defineComponent as _defineComponent } from 'vue'
import { useGetDashboardById } from '@/api/dashboards'
import { useRoute } from 'vue-router/composables'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewAnalyticsDashboard',
  setup(__props) {

const route = useRoute()
const dashboardId = computed(() => {
  if (route.name === 'new-metabase-dashboard') {
    return parseInt(route.params.id, 10)
  }
  return null
})

const { data: dashboardUrl, isFetching } = useGetDashboardById(dashboardId)

return { __sfc: true,route, dashboardId, dashboardUrl, isFetching }
}

})